import React from 'react';
import { formatBytes } from './utils';

const DAY_LABELS = { mon: 'Seg', tue: 'Ter', wed: 'Qua', thu: 'Qui', fri: 'Sex', sat: 'Sáb', sun: 'Dom' };
const KEYWORD_LABELS = { daily: 'Diariamente', weekly: 'Semanalmente', monthly: 'Mensalmente', hourly: 'A cada hora' };

function formatSchedule(s) {
  if (!s) return null;
  const lower = s.toLowerCase();
  if (KEYWORD_LABELS[lower]) return KEYWORD_LABELS[lower];
  // "mon,wed 02:00" or "sun 00:00"
  const m = s.match(/^([a-z,*]+)\s+(\d{1,2}:\d{2})$/i);
  if (m) {
    const days = m[1].split(',').map(d => DAY_LABELS[d.toLowerCase()] || d).join('/');
    return `${days} às ${m[2]}`;
  }
  // "02:00" — implicitly daily
  if (/^\d{1,2}:\d{2}$/.test(s)) return `Diariamente às ${s}`;
  return s;
}

function VMBackupsPanel({ backups, backupsLoading, onClose, onRefresh, schedules, schedulesLoading, schedulesAvailable }) {
  return (
    <div className="logs-panel">
      <div className="logs-header">
        <span className="logs-title">💾 Backups</span>
        <div className="logs-header-actions">
          <button className="logs-refresh-btn" onClick={onRefresh} disabled={backupsLoading}>
            {backupsLoading ? '...' : '⟳'}
          </button>
          <button className="logs-close-btn" onClick={onClose} title="Fechar">✕</button>
        </div>
      </div>

      <div className="backup-schedule-section">
        {schedulesLoading ? (
          <div className="backup-schedule-row loading">Verificando agendamento...</div>
        ) : schedulesAvailable === false ? (
          <div className="backup-schedule-row warn">⚠ Informação de agendamento indisponível</div>
        ) : schedules.length === 0 ? (
          <div className="backup-schedule-row warn">⚠ Sem agendamento de backup configurado</div>
        ) : (
          schedules.map((s, i) => (
            <div key={i} className={`backup-schedule-row ${s.enabled ? 'active' : 'inactive'}`}>
              <span className="bs-icon">{s.enabled ? '✓' : '○'}</span>
              <span className="bs-label">{formatSchedule(s.schedule) || '—'}</span>
              {s.storage && <span className="bs-storage">{s.storage}</span>}
              {s.comment && <span className="bs-comment">{s.comment}</span>}
            </div>
          ))
        )}
      </div>

      {backupsLoading ? (
        <div className="logs-empty">Carregando...</div>
      ) : backups.length === 0 ? (
        <div className="logs-empty">Nenhum backup encontrado para esta VM.</div>
      ) : (
        <div className="logs-list">
          {backups.map((b, i) => (
            <div key={i} className="backup-entry">
              <span className="backup-date">
                {b.ctime ? new Date(b.ctime * 1000).toLocaleString('pt-BR') : '—'}
              </span>
              <span className="backup-storage">{b.storage}</span>
              <span className="backup-format">{b.format || '—'}</span>
              <span className="backup-size">{formatBytes(b.size)}</span>
              {b.protected ? <span className="backup-protected">🔒</span> : <span />}
              {b.notes ? <span className="backup-notes" title={b.notes}>📝</span> : <span />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default VMBackupsPanel;
